export enum CoverTypeEnum {
  LEVEL_COVER = 'LEVEL_COVER',
  STRAIGHTLINE_DECREASING = 'STRAIGHTLINE_DECREASING',
  ANNUITY_DECREASING = 'ANNUITY_DECREASING',
}
